// Import Firebase functions
import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  deleteToken,
} from "firebase/messaging";

// import { firebaseConfig } from "../constant/staticData";

// const firebaseConfig = {
//   apiKey: "AIzaSyA7_5JMtpg_R4C_9hhrkfAe9Lvi5cBVZY8",
//   authDomain: "shindhi-9cdd4.firebaseapp.com",
//   projectId: "shindhi-9cdd4",
//   storageBucket: "shindhi-9cdd4.firebasestorage.app",
//   messagingSenderId: "234172007176",
//   appId: "1:234172007176:web:3ea89a95e0a8bb26b3a2bd",
//   measurementId: "G-3YF19YWZXG"
// };

const firebaseConfig = {
  apiKey: "AIzaSyCakPZ6nqLR00PVMBa1sLp3glKJPVq7yT8",
  authDomain: "sindhimedical-4c6d8.firebaseapp.com",
  projectId: "sindhimedical-4c6d8",
  storageBucket: "sindhimedical-4c6d8.firebasestorage.app",
  messagingSenderId: "351710418889",
  appId: "1:351710418889:web:14756417dd6ea67d66fa18",
  measurementId: "G-HS8S574H1N"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

let messaging = null;
try {
  messaging = getMessaging(app);
} catch (error) {
  console.warn("Firebase Messaging is not supported in this browser/environment:", error);
}

export { messaging };

/**
 * Request permission for notifications and get FCM token.
 */
export const requestForToken = async () => {
  if (!messaging) {
    console.warn("FCM messaging is not supported in this browser/environment.");
    return null;
  }
  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("Notification permission denied.");
      return null;
    }

    // Ensure VAPID key is provided
    const vapidKey = "BNTMD4Zby9o7k5f8GMkuJjOgjTj6LH6kBZkjJpYTSVg4PrW31S5HRoDRDoUX18lIix8VTLXxLVKPx5lrLEjs1l0";
    if (!vapidKey) {
      console.error("VAPID key is missing in environment variables.");
      return null;
    }

    const currentToken = await getToken(messaging, { vapidKey });
    // console.log('currentToken', currentToken)
    if (currentToken) {
      return currentToken;
    } else {
      console.warn("No registration token available.");
      return null;
    }
  } catch (error) {
    console.error("Error retrieving token: ", error);
    return null;
  }
};

/**
 * Remove the current FCM token.
 */
export const removeToken = async () => {
  if (!messaging) {
    console.warn("FCM messaging is not supported in this browser/environment.");
    return false;
  }
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: "BNTMD4Zby9o7k5f8GMkuJjOgjTj6LH6kBZkjJpYTSVg4PrW31S5HRoDRDoUX18lIix8VTLXxLVKPx5lrLEjs1l0",
    });
    if (currentToken) {
      await deleteToken(messaging);
      console.log("FCM token successfully deleted.");
      return true;
    } else {
      console.error("Error deleting FCM token");
      return false;
    }
  } catch (error) {
    console.error("Error deleting FCM token: ", error);
    return false;
  }
};

/**
 * Listen for incoming messages while the app is in the foreground.
 * This continuously listens to new messages and executes the callback function.
 */

export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging) {
      console.warn("FCM messaging is not supported in this browser/environment.");
      return;
    }
    // console.log("i m hit")
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });